/* BENDATA-FIX: 9 drop mode — countdown for [data-bnd-countdown="<ISO date>"]. Announces only at 1 h, 1 min and zero. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  document.querySelectorAll('[data-bnd-countdown]').forEach(function (el) {
    var t = Date.parse(el.getAttribute('data-bnd-countdown'));
    var root = el.closest('[data-bnd-drop]') || el;
    var live = root.querySelector('[data-bnd-cd-live]');
    var units = el.querySelectorAll('[data-u]');
    var prev, timer;
    if (isNaN(t)) { el.hidden = true; return; }
    function tick() {
      var s = Math.max(0, Math.floor((t - Date.now()) / 1000));
      var v = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
      for (var i = 0; i < units.length; i++) units[i].textContent = pad(v[i]);
      if (live && prev !== undefined) {
        var say = prev > 0 && s === 0 ? 'live' : prev > 60 && s <= 60 ? 'minute' : prev > 3600 && s <= 3600 ? 'hour' : '';
        if (say) live.textContent = el.getAttribute('data-say-' + say);
      }
      prev = s;
      if (!s) {
        clearInterval(timer);
        if (root.getAttribute('data-state') === 'before') root.setAttribute('data-state', 'live');
      }
    }
    tick();
    if (prev) timer = setInterval(tick, 1000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden && prev) tick(); });
  });
})();
